import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  padding-left: 40px;
  flex: 1;
  overflow: hidden;
`;
